import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { ApiService } from '../../services/index';

export type PresignedUpload = {
  link: string;
  name: string;
  uploadUrl: string;
};

// Mints direct-to-S3 upload URLs for a batch of picked files — one API round-trip for
// the whole drop, then the browser PUTs bytes straight to the bucket.
export const usePresignVaultUploads = () => {
  const presignUploads = useCallback(
    (files: { name: string; size: number; type: string }[]) =>
      ApiService.post<PresignedUpload[]>(
        { endpoint: BackendRoute.SHARE_CLASSES, routePath: ['file', 'presigned-uploads'] },
        { body: { files } },
      ),
    [],
  );

  return { presignUploads };
};
